import { InventoryLogCard } from './InventoryLogCard.jsx';
import { kioskApi } from '../lib/kiosk-api.js';

// Kiosk (shared iPad, PIN session) surface for waste + shift-meal logging.
// Reuses InventoryLogCard, wired to kioskApi so requests carry the
// Kiosk-Token session (the inventory routes resolve it via getKioskActor).
// Location + acting user come from the PIN session.
export function KioskInventoryView({ session }) {
  const call = (method, path, body) => kioskApi(method, path, body, session.token);
  return (
    <div style={{ maxWidth: 620, margin: '0 auto' }}>
      <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 12 }}>
        Log a dropped or spoiled item, or a shift meal you had. It updates inventory right away.
      </div>
      <InventoryLogCard location={session.location} user={session.user} apiFn={call} />
    </div>
  );
}
